module.exports = __webpack_public_path__ + "img/project12_5.jpg.56764154.webp";